<scip-dossier-summary [product]="productForDossierSummary" [productNode]="rootProductNodeDto"></scip-dossier-summary>
<div style="display: flex">
  <div style="flex: 1 1 66%">
    <scip-product-declaration-tree
      [tabIdentifier]="product?.id"
      (nodeIdentifierSelected)="handleNodeIdentifierSelected($event)"
    ></scip-product-declaration-tree>
  </div>
  <avano-divider layout="vertical" styleClass="a-divider-between-two-panels"></avano-divider>
  <div style="flex: 1 1 33%">
    <scip-declaration-node-editor [productIdentifier]="product.id" [selectedNodeIdentifier]="selectedNodeIdentifier"> </scip-declaration-node-editor>
  </div>
</div>
